import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/app/ProtectedRoute";

import MarketingLayout from "@/components/marketing/MarketingLayout";
import Home from "@/pages/marketing/Home";
import HowItWorks from "@/pages/marketing/HowItWorks";
import About from "@/pages/marketing/About";
import Privacy from "@/pages/marketing/Privacy";
import Terms from "@/pages/marketing/Terms";
import Contact from "@/pages/marketing/Contact";
import Demo from "@/pages/marketing/Demo";

import SignIn from "@/pages/auth/SignIn";
import Register from "@/pages/auth/Register";
import ResetPassword from "@/pages/auth/ResetPassword";

import AppShell from "@/components/app/AppShell";
import Dashboard from "@/pages/app/Dashboard";
import Timeline from "@/pages/app/Timeline";
import Calendar from "@/pages/app/Calendar";
import Commitments from "@/pages/app/Commitments";
import Insights from "@/pages/app/Insights";
import Profile from "@/pages/app/Profile";
import Onboarding from "@/pages/app/Onboarding";

import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App font-body">
      <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Marketing */}
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/trial" element={<Navigate to="/register" replace />} />
              <Route path="/demo" element={<Demo />} />
            </Route>

            {/* Auth */}
            <Route path="/signin" element={<SignIn />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Legacy route redirects */}
            <Route path="/auth/login" element={<Navigate to="/signin" replace />} />
            <Route path="/auth/register" element={<Navigate to="/register" replace />} />

            {/* Onboarding */}
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

            {/* App */}
            <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="timeline" element={<Timeline />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="commitments" element={<Commitments />} />
              <Route path="insights" element={<Insights />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
